export default {
  portalTitle: "Aldar Customer Portal",
  cancelText: "Cancel",
  viewMoreLabel: "View more",
  "406ErrorMessage":
    "Please remove any symbols, punctuation, or special characters and try again.",
  MAX_FILE_SIZE_EXCEEDED_MESSAGE: "File size exceeded",
  BREADCRUMB_BACK_TEXT: "Back",
  FILE_NOT_SUPPORTED_MESSAGE:
    "Please upload file in pdf, png, jpg, jpeg format.",
  DOCUMENT_UPLOAD_SUCCESS_TEXT: "Success",
  DOCUMENT_UPLOAD_FAILURE_TEXT: "Failed",
  PROFILE_PIC_UPLOAD_SUCCESS_TEXT: "Profile picture uploaded successfully",
  PROFILE_PIC_UPLOAD_FAILURE_TEXT:
    "There was a problem while uploading the profile picture",
  COOKIE_MESSAGE:
    "To use this site, cookies must be enabled. Please adjust your browser settings to proceed.",
  API_FAILURE_ERROR:
    "There was a problem while processing the information. Please try again later",
  DS_TIMER_EXPIRED: "Your reservation time has ended. Please check availability again or explore other available properties",
  DS_SEARCH_ERROR_PROPERTY_DETAILS_MISSING: "Oops! Required property details are missing. Please try again later.",
  DS_SEARCH_ERROR_UNIT_UNAVAILABLE: "This property is no longer available. Explore other similar options we think you'll like.",
  LEAD_ELIGIBILITY_ERROR:
    "User details already exist with Aldar are not eligible for Referral",
  SIGNZY_FAILURE_ERROR:
    "Oops ! there seem to be an issue with the  servers, Don't let that stop you from continuing the journey",
  FILE_DOWNLOAD_ERROR_PRIMARY_MESSAGE: "File Download Failed",
  FILE_DOWNLOAD_ERROR_PRIMARY_TEXT:
    "We apologize, but it seems that the file download failed. Click ",
  FILE_DOWNLOAD_ERROR_ACTION_TEXT: "here",
  FILE_DOWNLOAD_ERROR_SECONDARY_TEXT: "to raise a request.",
  requiredErrorMessage: "Please fill in all the required information.",
  UNSUPPORTED_FILE_FORMAT: "Download failed due to unsupported file format.",
  formatErrorMessage: "Please provide the information in the right format",
  ERROR_MESSAGE_SUBJECT_COMMENTS:'Please remove any symbols, punctuation, or special characters and try again',
  ERROR_DOC_NOT_FOUND: "Sorry document not found. Please try later.",
  uploadClickText: "Click to Upload",
  dragDropText: "or drag and drop here",
  fileFormatSizeText: "JPG, PNG or PDF, file size max 5MB",
  signDocumentDocusignButtonText: "Sign Document",
  signDoneText: "Document Signed",
  "Value must be greater than passport issue date":
    "Value must be greater than passport issue date",
  "Value must be greater than passport expiry date":
    "Value must be greater than passport expiry date",
  "Value must be greater than current date":
    "Value must be greater than current date",
  "Value must be greater than person birthdate":
    "Value must be greater than person birthdate",
  "Value must be less than passport issue date":
    "Value must be less than passport issue date",
  "Value must be less than current date":
    "Value must be less than current date",
  "Value must be less than person birthdate":
    "Value must be less than person birthdate",
  "Value must be less than passport expiry date":
    "Value must be less than passport expiry date",
  "Please provide the information in the right format":
    "Please provide the information in the right format",
  "Date of birth must be less than the current date":
    "Date of birth must be less than the current date",
  "Not a mobile number": "Not a mobile number",
  "Expiry date must be in the future.": "Expiry date must be in the future.",
  "Expiry date must be greater than person's birthdate.":
    "Expiry date must be greater than person's birthdate.",
  "Issued date must be less than current date.":
    "Issued date must be less than current date.",
  "Issued date must be before the passport expiry date.":
    "Issued date must be before the passport expiry date.",
  "Issued date must be after the person's birthdate.":
    "Issued date must be after the person's birthdate.",
  "Issued date must be before the national id expiry date.":
    "Issued date must be before the national id expiry date.",
  "Expiry date must be after the passport issue date.":
    "Expiry date must be after the passport issue date.",
  "Expiry date must be after the person's birthdate.":
    "Expiry date must be after the person's birthdate.",
  "Invalid characters in postal code.": "Invalid characters in postal code.",
  "Postal code must contain at least 4 characters.":
    "Postal code must contain at least 4 characters.",
  "Passport number must be 15 characters or less.":
    "Passport number must be 15 characters or less.",
  "Please provide a valid mobile number":
    "Please provide a valid mobile number",
  "Please provide a unique mobile number":
    "Please provide a unique mobile number",
  "Please provide a valid email": "Please provide a valid email",
  "Please provide a unique email": "Please provide a unique email",
  "This email is already used by logged in user. Please provide a different email":
    "This email is already used by logged in user. Please provide a different email",
  sessionExpiredMessage: "Sorry, your session has expired. Please login again.",
  googleRecaptchaInvalidText: "Captcha validation failed. Please try again!",
  mobileValidityErrorText: "Please provide valid email and mobile number",
  accountManagerHeadingText: "Your dedicated Customer Care Executive",
  accountManagerDescription:
    "Kindly contact your dedicated Customer Care Executive for any further communication.",
  accountManagerLeftInfoSectionLine2Text: "Dedicated Customer Care Executive",
  formatErrorMessageGreaterThanTwo: "Card name: Maximum two words.",
  noPropertiesMessage: "You are not eligible to log into the portal",
  useFasttrackLink:
    "To complete your fasttrack process, please login through the link sent to your email.",
  noDigitalSalesFound: "Sorry, no sales record found. Please try later.",
  cookiesAcceptButtonText: "Accept",
  cookiesDeclineButtonText: "No, I want more info",
  cookieBannerInnerText1:
    "We use cookies to offer you a better user experience. By continuing to use this website, you consent to the use of cookies in accordance with our",
  cookieBannerInnerText2: "Privacy policy",
  cookieBannerInnerText3: "",
  TIMEOUT_ERROR:
    "There was a problem while processing the information. Please retry the process by going back to the email entry screen",
  noPaymentDueText: "No payment due",
  user_locked_out:
    "Your account has been locked for 15 mins. Please contact Aldar contact centre for resolution.",
  user_disabled: "Your account is disabled. Please sign up again.",
  third_attempt:
    "You have two more login attempts left before your account gets locked for 15 mins",
  fourth_attempt:
    "You have one more login attempt left before your account gets locked for 15 mins",
  submit:'Submit',
  done:'Done',
  next:'Next',  
  uploadFailureMsg:'Upload failed',
  invalidFileTypeMsg:'Unsupported file type',
  fetchFailureMsg:'Failed to fetch document',
  DONE : "Done",
  "SOA_download_success" : "Statement of Account downloaded successfully",
  DS_UNIT_ALREADY_LOCKED_ERROR: "This unit is already locked by another user",
  PROFILE_UPDATE_OTP_GENERATION_FAILED: "Sorry. There was a problem in generating OTP. Please try later.",
  PROFILE_UPDATE_OTP_REGENERATION_FAILED: "Sorry. There was a problem in resending OTP. Please try later.",
  EXPIRED_ID_MESSAGE: "Your ID has expired. Please upload a valid ID",
  DLP_PERIOD: "DLP period",
  DLP_ACTIVE_UNTIL: "DLP Active Until"
};
